(function() {
  var WISHLIST_KEY = 'kc_wishlist';

  function showToast(message) {
    var toast = document.getElementById('kc-global-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'kc-global-toast';
      toast.className = 'kc-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('show');
    setTimeout(function() {
      toast.classList.remove('show');
    }, 3000);
  }

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch(e) { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }

  function toggleWishlist(btn) {
    var id    = btn.dataset.productId;
    var list  = getWishlist();
    var idx   = list.findIndex(function(p) { return p.id === id; });

    if (idx > -1) {
      list.splice(idx, 1);
      btn.classList.remove('kc-wishlisted');
    } else {
      list.push({
        id:    id,
        handle: btn.dataset.productHandle,
        title:  btn.dataset.productTitle,
        url:    btn.dataset.productUrl,
        img:    btn.dataset.productImg,
        price:  btn.dataset.productPrice
      });
      btn.classList.add('kc-wishlisted');
    }
    saveWishlist(list);
    showToast(idx > -1 ? 'Removed from wishlist' : 'Added to wishlist');
    syncWishlistUI();
  }

  function syncWishlistUI() {
    var list = getWishlist();
    document.querySelectorAll('.kc-wishlist-btn').forEach(function(btn) {
      var id = btn.dataset.productId;
      if (list.some(function(p) { return p.id === id; })) {
        btn.classList.add('kc-wishlisted');
      } else {
        btn.classList.remove('kc-wishlisted');
      }
    });

    // Update global wishlist badges (e.g. in header)
    var badges = document.querySelectorAll('.kc-wishlist-badge');
    badges.forEach(function(badge) {
      badge.textContent = list.length;
      if (list.length > 0) {
        badge.style.display = 'block';
      } else {
        badge.style.display = 'none';
      }
    });
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    btn.disabled = true;

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function(r) { return r.json(); })
    .then(function(item) {
      return fetch('/cart.js');
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('[data-cart-count], .cart-count, .cart-item-count').forEach(function(el) {
        el.textContent = cart.item_count;
      });
      
      // Notify theme
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));

      // Open drawer
      var drawer = document.querySelector('cart-drawer-component, cart-drawer, #CartDrawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      
      showToast('Added to cart!');
      btn.disabled = false;
    })
    .catch(function(err) {
      console.error(err);
      showToast('Error adding to cart');
      btn.disabled = false;
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    syncWishlistUI();
    document.addEventListener('click', function(e) {
      var wBtn = e.target.closest('.kc-wishlist-btn');
      if (wBtn) { toggleWishlist(wBtn); return; }

      var atcBtn = e.target.closest('.kc-atc-btn');
      if (atcBtn) { addToCart(atcBtn.dataset.variantId, atcBtn); return; }
    });
  });

  // Re-sync on dynamic loads
  document.addEventListener('shopify:section:load', syncWishlistUI);
  // Listen for custom events if other sections load products
  document.addEventListener('kc:cards:loaded', syncWishlistUI);

})();
